

import axios from "axios";
import { baseUrl } from "../apiUrl";
import { buildQueryString, QueryParam } from "../queryUtils";
import { DivisionMileStones, DivisionMileStone,MileStonesRequest } from "./types";




// Get all Division MileStones
export const getdivisionMilestones = async (query: QueryParam): Promise<DivisionMileStones> => {
       try {
              const response = await axios.get<DivisionMileStones>(`${baseUrl}/clo-dvs/division/milestones?${buildQueryString(query)}`);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to fetch Division MileStones: ${error}`);
       }
};


// Backend expected request format


export const createDivisionMileStone = async (division: DivisionMileStone): Promise<DivisionMileStone> => {
       try {
              const response = await axios.post<DivisionMileStone>(`${baseUrl}/clo-dvs/division/milestones`, division);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to create Division MileStone: ${error}`);
       }
};

export const createMileStonesBatch = async (milestones: DivisionMileStone[], mode: 'draft' | 'released', workFlowId: string): Promise<DivisionMileStone[]> => {
       try {
              const request: MileStonesRequest = {
                     milestones: milestones.map(milestone => ({
                            automated: milestone.automated,
                            isDefault: milestone.isDefault,
                            divisionCode: milestone.divisionCode,
                            mileStoneCode: milestone.mileStoneCode,
                            mileStoneName: milestone.mileStoneName,
                            mileStoneOrder: milestone.mileStoneOrder,
                            taskCode: milestone.taskCode,
                            taskName: milestone.taskName,
                            taskOrder: milestone.taskOrder,
                            status: milestone.status,
                            createdBy: milestone.createdBy,
                     })),
                     mode,
                     workFlowId,
              };

              const response = await axios.post<DivisionMileStone[]>(`${baseUrl}/clo-dvs/division/milestones`, request);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to create Division MileStones batch: ${error}`);
       }
};

// Update a specific Division MileStone by ID and divisionCode ID
export const updateDivisionMileStone = async (division: Partial<DivisionMileStone>): Promise<DivisionMileStone> => {
       try {
              const response = await axios.patch<DivisionMileStone>(`${baseUrl}/clo-dvs/division/milestones`, division);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to update Division MileStone with ID ${division}: ${error}`);
       }
};

// Update multiple Division MileStones in batch
export const updateMileStonesBatch = async (milestones: DivisionMileStone[], mode: 'draft' | 'released', workFlowId: string): Promise<DivisionMileStone[]> => {
       try {
              const request: MileStonesRequest = {
                     milestones: milestones.map(milestone => ({
                            id: milestone.id,
                            automated: milestone.automated,
                            isDefault: milestone.isDefault,
                            divisionCode: milestone.divisionCode,
                            mileStoneCode: milestone.mileStoneCode,
                            mileStoneName: milestone.mileStoneName,
                            mileStoneOrder: milestone.mileStoneOrder,
                            taskCode: milestone.taskCode,
                            taskName: milestone.taskName,
                            taskOrder: milestone.taskOrder,
                            status: milestone.status,
                            updatedBy: milestone.updatedBy || 'system', // Default to 'system' if not provided
                     })),
                     mode,
                     workFlowId,
              };
              const response = await axios.patch<DivisionMileStone[]>(`${baseUrl}/clo-dvs/division/milestones`, request);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to update Division MileStones batch: ${error}`);
       }
};

// Mark draft records for deletion
export const deleteDivisionMileStone = async (id: string,divisionCode: string): Promise<void> => {
       try {
            
              const deleteRequest = {
                     id: id,
                     divisionCode: divisionCode
              }
              const response = await axios({
                     method: 'delete',
                     url: `${baseUrl}/clo-dvs/division/milestones`,
                     data: deleteRequest
              });
              return response.data;
       } catch (error) {
              throw new Error(`Failed to mark draft records for deletion: ${error}`);
       }
};